import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { VehicleMaintenanceStatusEnum } from '../enums/vehicle-maintenance-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function vehicleMaintenanceStatusToColor(
	status: VehicleMaintenanceStatusEnum,
): string {
	switch (status) {
		case VehicleMaintenanceStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case VehicleMaintenanceStatusEnum.IN_PROGRESS:
			return RecordColorEnum.GREEN;

		case VehicleMaintenanceStatusEnum.COMPLETED:
			return RecordColorEnum.BLUE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
